<template>
  <div>
      <div
        dir="ltr"
        style="margin-top: 0; padding-top: 0;"
        class="toggle_resources flex flex_align_center flex_justify_center"
      >
        <a
          @click="toggleResource('Applicants')"
          :class="{ 'is-info': resource_selected == 'Applicants' }"
          class="button is-link"
          >Applicants</a
        >
        <div style="width: 10px;"></div>
        <a
          @click="toggleResource('Companies')"
          :class="{ 'is-info': resource_selected == 'Companies' }"
          class="button is-link"
          >Companies</a
        >
      </div>
      <div style="font-size: 14px;">
        <search-modal-applicants v-if="isShowResource('Applicants')" :results="applicants_search_results"></search-modal-applicants>
        <search-modal-companies v-if="isShowResource('Companies')" :results="companies_search_results"></search-modal-companies>
      </div>
      <div v-if="is_searching" class="loading center_horizontal"></div>
  </div>
</template>
<script>
import { isNumeric } from '@/classes/my_utils.js'
import SearchModalApplicants from '@/components/SearchModalApplicants'
import SearchModalCompanies from '@/components/SearchModalCompanies'
export default {
  name: 'search-form',
  props: ['payload'],
  data () {
    return {
      resource_selected: 'no_resource_selected',
      is_searching: false,
      is_paginating: false,
      applicants_search_results: [],
      companies_search_results: [],
      search_timeout: {}
    }
  },
  created: function () {
    this.search()
  },
  watch: {
    payload: {
      handler () {
        this.search()
      },
      deep: true
    }
  },
  methods: {
    isShowResource (resource) {
      return this.resource_selected == 'no_resource_selected' ? true : this.resource_selected == resource
    },
    toggleResource (resource) {
      let resource_selected = this.resource_selected == resource ? 'no_resource_selected' : resource
      this.resource_selected = resource_selected
      if (resource_selected == 'Texts') {
        this.makeTextsRequest(this.getRequestParams())
      }
    },
    search () {
      clearTimeout(this.search_timeout)
      this.is_searching = true
      this.search_timeout = setTimeout(this.makeRequests, 500)
    },
    makeRequests () {
      let default_params = this.getRequestParams()
      this.makeApplicantsRequest(default_params)
      this.makeCompaniesRequest(default_params)
    },
    getRequestParams () {
      let keyword = this.payload.keyword
      let is_id_search = isNumeric(keyword) && !keyword.startsWith('0')
      let id = is_id_search ? keyword : ''
      return {
        keyword,
        id,
      }
    },
    makeApplicantsRequest (params) {
      this.makeRequest({
        resource_name: 'applicants',
        api: `/offers/${params.id}/?applicant_name=${params.keyword}`,
      })
    },
    makeCompaniesRequest (params) {
      this.makeRequest({
        resource_name: 'companies',
        api: `/companies/${params.id}/?company_name=${params.keyword}`,
      })
    },
    makeRequest (params) {
      this.is_searching = true
      this.$network_utils.caller.request({ method: 'get', url: params.api, data: params.data }).then(response => {
        this.setResourceSearchResults({
          resource_name: params.resource_name,
          search_results: Array.isArray(response) ? response : [response]
        })
      }).catch(() => {
        this.setResourceSearchResults({
          resource_name: params.resource_name,
          search_results: []
        })
      })
    },
    setResourceSearchResults (params) {
      this.is_searching = false
      this[params.resource_name + '_search_results'] = params.search_results
    },
  },
  components: {
    SearchModalApplicants,
    SearchModalCompanies,
  }
}
</script>
<style scoped>
.loading {
  position: fixed;
  bottom: 20px;
  margin-top: 30px;
}
.toggle_resources {
  padding-top: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
</style>
